<div>
    <button mat-raised-button color="primary" class="m-2" *ngIf="!testInProcess"  (click)="startRecording()">Test AI</button>
    <button mat-raised-button color="warn" class="m-2" *ngIf="testInProcess" (click)="stopRecording()">Stop</button>
</div>
<audio #audio controls [hidden]="true" style="position: absolute;"></audio>